import {useContext} from "react";
import {WallContext} from "../../contexts/WallContext";
import AnnouncementCard from "./AnnouncementCard";

export default function SideOverview() {
    const wall = useContext(WallContext);
    const metadata = wall.metadata;

    const mockAnnouncements = [
        {
            title: "Valentine's Challenge",
            text: "Come on 14/02 after 6PM to participate in a bouldering contest on new routes.",
            date: "05/02",
        },
        {
            title: "Climbuddy is here!",
            text: "Track the newest routes, manage your climber log and share your achievements with friends.",
            date: "23/01",
        },
    ]

    return (
        <>
            <h2 key="name" className="text-4xl">{metadata["name"]}</h2>
            {"location" in metadata &&
                <p key="location" className="mt-5 text-xl">{metadata["location"]}</p>
            }
            {"description" in metadata &&
                <p key="description" className="mt-5">{metadata["description"]}</p>
            }

            <div className="mb-5"></div>
            <h3 className="text-3xl">Announcements</h3>
            <div className="mb-3"></div>
            {mockAnnouncements.map((announcement, i) =>
                <div key={i}>
                    <AnnouncementCard announcement={announcement}/>
                </div>
            )}
        </>
    );
}